import React from 'react';
import SideMenu from "../../components/SideMenu/SideMenu"
import ClientContent from "./ClientContent"
import styles from './Client.module.scss';
import { useEffect } from 'react';
import {useParams} from 'react-router-dom';


function Clients(props) {
  const params = useParams();;
  useEffect(() => {
    document.title = 'Cliente';
  }, []);

  return (
    <div className={styles.root}>
      <SideMenu />
      <ClientContent uuid={params.client}/>
    </div>
  );
}

export default Clients;